class ProductRepository {
  /**
   * @name ProductRepository#api
   * @type {Api}
   */

  /**
   * @name ProductRepository#maxCustomerGroupId
   * @type {int}
   */

  /**
   * @param api
   */
  constructor(api) {
    this.api = api
  }

  setMaxCustomerGroupId(maxCustomerGroupId) {
    this.maxCustomerGroupId = maxCustomerGroupId
  }

  findProductWithBasePricesAndCost(searchTerm, regionId, startDate, endDate) {
    let params = {
      codePrefix: searchTerm
    }
    return this.api.products.getSome(params, 50)
      .then(products => this.mapBasePricesAndCostToProducts(products, regionId, this.maxCustomerGroupId, startDate, endDate))
  }

  getProductsWithBasePricesAndCost(productIds, regionId, startDate, endDate) {
    return this.api.products.getByIds(productIds)
      .then(products => {
        return this.mapBasePricesAndCostToProducts(products, regionId, this.maxCustomerGroupId, startDate, endDate).then(productsWithBasePricesAndCost => {
          return productsWithBasePricesAndCost
        })
      })
  }

  mapBasePricesAndCostToProducts(products, regionId, customerGroupId, startDate, endDate) {
    return this.mapRegionalBasePricesToProducts(products, regionId, startDate, endDate)
      .then(products => {
        return this.mapRegionalCustomerGroupBasePricesToProducts(products, regionId, customerGroupId, startDate, endDate)
      })
      .then(products => this.mapRegionCostToProducts(products, regionId, startDate, endDate))
  }

  mapRegionalBasePricesToProducts(products, regionId, startDate, endDate) {
    return this.api.regionPriceLists.getBasePriceList(regionId, startDate, endDate)
      .then(priceList => this.mapProductRegionBasePriceFromPriceList(products, priceList))
  }

  mapRegionalCustomerGroupBasePricesToProducts(products, regionId, customerGroupId, startDate, endDate) {
    return this.api.regionCustomerGroupPriceLists.getBasePriceList(regionId, customerGroupId, startDate, endDate)
      .then(priceList => this.mapProductRegionCustomerGroupBasePriceFromPriceList(products, priceList))
  }

  mapRegionCostToProducts(products, regionId, startDate, endDate) {
    return this.api.regionSupplierPriceLists.getAll(regionId, startDate, endDate)
      .then(priceLists => this.mapProductRegionCostFromPriceList(products, priceLists))
  }

  mapProductRegionBasePriceFromPriceList(products, priceList) {
    return products.map(product => {
      product.regionBasePrice = priceList.pricelistRules.reduce((result, pricelistRule) => {
        if (pricelistRule.id !== product.productID) {
          return result
        }

        return pricelistRule.price
      }, product.price)
      return product
    })
  }

  mapProductRegionCustomerGroupBasePriceFromPriceList(products, priceList) {
    return products.map(product => {
      product.regionCustomerGroupBasePrice = priceList.pricelistRules.reduce((result, pricelistRule) => {
        if (pricelistRule.id !== product.productID) {
          return result
        }

        return pricelistRule.price
      }, product.regionBasePrice)

      return product
    })
  }

  mapProductRegionCostFromPriceList(products, priceLists) {
   // console.log('mapProductRegionCostFromPriceList priceLists:', priceLists)
    return products.map(product => {
   //   console.log('mapProductRegionCostFromPriceList: product 1', product)

      priceLists.forEach((priceList) => {

        console.log('mapProductRegionCostFromPriceList priceList:', priceList)
        if (product.regionCost) {
         // console.log('Price is set');
          //return product
        } else {
        //  console.log('Price to be set, looking...');

          if (priceList.pricelistRules) {
            product.regionCost = priceList.pricelistRules.reduce((result, pricelistRule) => {

              //   console.log('mapProductRegionCostFromPriceList: producT', product)
              //  console.log('mapProductRegionCostFromPriceList: pricelistRule', pricelistRule)

              if (pricelistRule.productID !== product.productID) {
               // console.log('mapProductRegionCostFromPriceList: ret result', result)
                return result
              }


             // console.log('mapProductRegionCostFromPriceList: ret pricelistRule.price', pricelistRule.price)
              return pricelistRule.price
            }, product.cost)

          }
          else
          {
            product.regionCost = product.cost
          }
        }
      });

      return product
    });
  }


}


export default ProductRepository



// WEBPACK FOOTER //
// ./src/model/ProductRepository.js